module.exports = __webpack_public_path__ + "img/logo.2f1c3833.png";